import React from 'react';
import { Line } from '@ant-design/charts';
import { Progress,Card, Col, Row  } from 'antd';
import classes from "./dashboard.module.css";
const Dashboard= () => {
  const data = [
    { year: '1991', value: 3 },
    { year: '1992', value: 4 },
    { year: '1993', value: 3.5 },
    { year: '1994', value: 5 },
    { year: '1995', value: 4.9 },
    { year: '1996', value: 6 },
    { year: '1997', value: 7 },
    { year: '1998', value: 9 },
    { year: '1999', value: 13 },
  ];

  const config = {
    data,
    height: 230,
    xField: 'year',
    yField: 'value',
    point: {
      size: 5,
      shape: 'diamond',
    },
  };
  return(
    <>
    <h2>Dashboard</h2>
    <hr/>
    <div className="site-card-wrapper">
    <Row gutter={16}>
      <Col span={6}>
        <Card title="Total Audits Conducted" bordered={false}>
          0
        </Card>
      </Col>
      <Col span={6}>
        <Card title="Average Score" bordered={false}>
          0
        </Card>
      </Col>
      <Col span={6}>
        <Card title="Total Non Compliances" bordered={false}>
          0
        </Card>
      </Col>
      <Col span={6}>
        <Card title="Action Plans" bordered={false}>
          0
        </Card>
      </Col>
    </Row>
  </div>
  <div>

  </div>
  <div className={classes.place}> 
    <div className={classes.graph}>
      <h3>Past Audits</h3>
      <Line {...config} style={{ width: "80%",background:'white' }}/>;
      </div>
    
    <div className="site-card-border-less-wrapper">
      <Card title="Top Performer" bordered={false} style={{ width:300 }}>
        <p>Lewis</p>
        <p>Larl</p>
        <p>John</p>
        <p>Johnas</p>
        <p>Kroty</p>
        <p>Swift</p>
      </Card>
    </div>
  </div>
  <div className={classes.place} >

    <div style={{ width:"40%" ,height:"400",background:'white',padding:'auto' ,paddingTop:"10"}}>
    <div className={classes.progress}>Status Of Compilances Today</div>
    <div className={classes.container}>
    <Progress percent={30} />
    <Progress percent={50} status="active" />
    <Progress percent={70} status="exception" />
    <Progress percent={100} />
    <Progress percent={50} showInfo={false} />

</div>
  </div>

  <div className="site-card-border-less-wrapper">
    <Card title="Current Status" bordered={false} style={{ width: 300,height:250 }}>
    <div className={classes.bar}>
    <Progress type="dashboard" percent={75}  />
    </div>
    </Card>
  </div>
  <div className="site-card-border-less-wrapper">
    <Card title="Outlet Status" bordered={false} style={{ width: 300 }}>
      <p>41c, Kailash Nagar, Ludhiana</p>
      <p>11t, Shimla Colony, Ludhiana</p>
      <p>47c, Baldev Nagar, Ludhiana</p>
      <p>54b, Kavi Nagar, Ludhiana</p>
    </Card>
  </div>
  </div>
  </>
  ) 
};
export default Dashboard; 